'use strict';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Pagination;
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Button = _interopRequireDefault(require("@mui/material/Button"));
const _excluded = ["current", "total"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function Pagination(_ref) {
  let {
      current = 0,
      total = 0
    } = _ref,
    props = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  const size = props['items-per-page'] || 30;
  const pages_count = parseInt(total / size);
  let pages = [];
  if (total > 0) {
    pages.length = total % size > 0 ? pages_count + 1 : pages_count;
  }
  let rendered_pages = [],
    additional = 2;
  if (pages.length <= 6)
    // display all pages
    {
      rendered_pages = Array.from(pages).map((empty, i) => i);
    } else {
    rendered_pages = getNumbers({
      count: pages.length,
      current,
      additional
    });
  }
  rendered_pages = rendered_pages.map(function (number, i) {
    const is__active = number === current;
    let output = /*#__PURE__*/_react.default.createElement("li", {
      className: "c-pagination__page",
      key: number
    }, /*#__PURE__*/_react.default.createElement(_Button.default, {
      className: 'c-pagination__page-btn' + (is__active ? ' active' : ''),
      onClick: e => props.onChange(e, number)
    }, number + 1));
    if (number > 0 && number < pages.length) {
      const miss__prev_page = number - 1 > 0 && number + 1 < pages.length && rendered_pages.includes(number - 1) === false;
      const miss__next_page = number + 1 < pages.length && rendered_pages.includes(number + 1) === false;
      output = /*#__PURE__*/_react.default.createElement(_react.Fragment, {
        key: number
      }, miss__prev_page ? /*#__PURE__*/_react.default.createElement("li", {
        className: "c-pagination__suspension"
      }, "...") : undefined, output, miss__next_page ? /*#__PURE__*/_react.default.createElement("li", {
        className: "c-pagination__suspension"
      }, "...") : undefined);
    }
    return output;
  });
  let infos;
  if (total === 0) {
    infos = /*#__PURE__*/_react.default.createElement("span", {
      className: "c-pagination__infos"
    }, "Aucun r\xE9sultat.");
  } else if (total <= size) {
    infos = /*#__PURE__*/_react.default.createElement("span", {
      className: "c-pagination__infos"
    }, "1-", total);
  } else {
    const max = (current + 1) * size;
    infos = /*#__PURE__*/_react.default.createElement("span", {
      className: "c-pagination__infos"
    }, 1 + current * size + '-' + (max > total ? total : max), ' sur ' + total);
  }
  const output = /*#__PURE__*/_react.default.createElement("div", {
    className: "c-pagination"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "c-pagination__left"
  }), rendered_pages.length > 1 ? /*#__PURE__*/_react.default.createElement("ul", {
    className: "c-pagination__pages"
  }, rendered_pages) : undefined, infos);
  return output;
}
function getNumbers(_ref2) {
  let {
    count,
    current,
    additional = 2
  } = _ref2;
  const last_page = count - 1;
  let numbers = [0, current, last_page];

  // Add one page to the end to bring balance
  if (current === 0) {
    numbers.push(current + additional * 2 + 1);
  }

  // Add one page to the start to bring balance
  if (current === count - 1) {
    numbers.push(current - additional * 2 - 1);
  }
  let left_bonus = 0,
    right_bonus = 0;
  for (let i = 1; i <= additional; i++) {
    // Before the current page
    if (current - i > 0) {
      numbers.push(current - i);
    } else
      // Move it after to bring balance
      {
        numbers.push(current + additional + ++right_bonus);
      }

    // After the current page
    if (current + i < last_page) {
      numbers.push(current + i);
    } else if (current + i >= last_page)
      // Move it before to bring balance
      {
        numbers.push(current - additional - ++left_bonus);
      }
  }

  // Remove duplicates and sort by page
  return numbers.filter(number => number >= 0 && number <= count).reduce(function (pages, number) {
    if (pages.includes(number) == false) {
      pages.push(number);
    }
    return pages;
  }, []).sort((a, b) => a > b ? 1 : -1);
}
Pagination.propTypes = {
  current: _propTypes.default.number,
  size: _propTypes.default.number,
  total: _propTypes.default.number
};
